import React, { useContext } from 'react';

export const ApiContext = React.createContext(null);

export const useApi = () => {
  return useContext(ApiContext);
};



// WEBPACK FOOTER //
// ./src/hooks/useApi.js